import { FETCH_DOCS_LOADING, FETCH_DOCS_DONE, FETCH_DOCS_ERROR,
  DOWNLOAD_DOCS_LOADING, DOWNLOAD_DOCS_DONE, DOWNLOAD_DOCS_ERROR,
  UPLOAD_DOCS_LOADING, UPLOAD_DOCS_DONE, UPLOAD_DOCS_ERROR } from './actions'

export default {
  [FETCH_DOCS_LOADING] (state) {
    state.isLoading = true
  },

  [FETCH_DOCS_DONE] (state, docs) {
    state.docs = docs
    state.isLoading = false
  },

  [FETCH_DOCS_ERROR] (state, error) {
    state.error = error
    state.isLoading = false
  },

  [DOWNLOAD_DOCS_LOADING] (state) {
    state.isDownloading = true
  },

  [DOWNLOAD_DOCS_DONE] (state, items) {
    // state.docs = []
    state.isDownloading = false
  },

  [DOWNLOAD_DOCS_ERROR] (state, error) {
    state.errorDownloading = error
    state.isDownloading = false
  },

  [UPLOAD_DOCS_LOADING] (state) {
    state.isUploading = true
    state.errorUploading = false
  },

  [UPLOAD_DOCS_DONE] (state, item) {
    state.doc = item
    state.isUploading = false
    state.errorUploading = false
  },

  [UPLOAD_DOCS_ERROR] (state, error) {
    state.errorUploading = true
    state.isUploading = false
    state.doc = {}
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/settings/documents/mutations.js